import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import api from "../../util/api";
import swal from "sweetalert";
import { Typewriter } from "react-simple-typewriter";

import Header from "../common/Header";

import HeroHand from "../assets/img/hero-hand.png";
import Bag from "../assets/img/bag.png";
import Hold from "../assets/img/hold.png";
import Card from "../assets/img/3d-card.png";
// import Card from "../assets/img/people-card.png";
import Phone from "../assets/img/phone-hand.png";
import Step from "../assets/img/exchange.png";
import Wallet from "../assets/img/wallet.png";

import Playstore from "../assets/img/playstore.svg";
import Apple from "../assets/img/apple.svg";

function LandingPage() {
  const navigate = useNavigate();
  const email = useRef("");
  const password = useRef("");
  const [button, setButton] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loggedInUser = localStorage.getItem("user");
    if (loggedInUser) {
      const foundUser = JSON.parse(loggedInUser);
      setUser(foundUser);
      navigate("/dashboard");
    }
  }, []);

  async function loginUser() {
    const userData = {
      email: email.current.value,
      password: password.current.value,
    };
    try {
      const res = await api.post("/admin/login", userData, {
        headers: {
          // "x-access-token": "token-value",
        },
      });
      if (res.data.success) {
        // store the user in localStorage
        localStorage.setItem("token", res.data.user["token"]);
        localStorage.setItem("user", JSON.stringify(res.data.user));

        swal("Success!", res.data.message, "success", {
          button: false,
          timer: 1500,
        });
        navigate("/dashboard");
      }
    } catch (err) {
      swal("Login Failed!", "" + err.response.data.message, "error", {
        button: false,
        timer: 1500,
      });
    }
  }

  return (
    <div>
      <Header />
      <section className="hero-section">
        <div className="container">
          <div class="gradient"></div>
          <div className="row">
            <div className="col text-center">
              <h2
                className="hero-text"
                data-aos="fade-right"
                data-aos-duration="2000"
              >
                Convert your crypto asset to fiat fast and easy
              </h2>
              <p className="hero-subtext" data-aos="fade-up">
                Create an account with us and start exchanging your crypto
                assets with fiat at best rates, easy and seamless.
              </p>
              <div className="row">
                <div className="col-2"></div>
                <div className="row col-8" data-aos="fade-up">
                  <div className="col">
                    <a className="btn btn-primary" href="/login">
                      Get Started
                    </a>
                  </div>
                  <div className="col">
                    <a className="btn btn-secondary" href="/about">
                      About Us
                    </a>
                  </div>
                </div>
                <div className="col-2"></div>
              </div>
            </div>
            <div className="col d-none d-lg-block">
              <div>
                <img src={HeroHand} data-aos="zoom-in-up" />
              </div>
            </div>
          </div>
          <div class="people">
            <p data-aos="fade-up">
              Putting smiles on the faces of
              <b> 100,000+</b> people
            </p>
            <div class="people-row">
              <img
                data-aos="fade-left"
                data-aos-anchor="#people-anchor"
                data-aos-offset="500"
                data-aos-duration="500"
                src="https://www.shutterstock.com/image-photo/image-handsome-smiling-young-african-260nw-722913181.jpg"
                class="p-image"
              />
              <img
                data-aos="fade-left"
                data-aos-anchor="#people-anchor"
                data-aos-offset="500"
                data-aos-duration="500"
                src="https://as2.ftcdn.net/v2/jpg/02/46/14/95/1000_F_246149573_1dbnEopMZjSflWG4ZvojXhVVV8cTewTW.jpg"
                class="p-image"
              />
              <img
                data-aos="fade-left"
                data-aos-anchor="#people-anchor"
                data-aos-offset="500"
                data-aos-duration="500"
                src="https://media.istockphoto.com/id/1152601942/photo/young-woman-wearing-spectacles.jpg?b=1&s=170667a&w=0&k=20&c=X5i7QCli9juu8H5GNuQWEnJEUe6hc-3Ts95OK7NjC-0="
                class="p-image"
              />
              <img
                data-aos="fade-left"
                data-aos-anchor="#people-anchor"
                data-aos-offset="800"
                data-aos-duration="500"
                src="https://media.istockphoto.com/id/1144287292/photo/headshot-portrait-of-happy-mixed-race-african-girl-wearing-glasses.jpg?b=1&s=170667a&w=0&k=20&c=JosednIBilI8XY47p_R75vNPRPVNm7ky4JB1DhJCoS4="
                class="p-image"
              />
              <img
                data-aos="fade-left"
                data-aos-anchor="#people-anchor"
                data-aos-offset="1000"
                data-aos-duration="500"
                src="https://www.shutterstock.com/image-photo/image-handsome-smiling-young-african-260nw-722913181.jpg"
                class="p-image"
              />
              <img
                data-aos="fade-left"
                data-aos-anchor="#people-anchor"
                data-aos-offset="1200"
                data-aos-duration="500"
                src="https://images.unsplash.com/photo-1560365163-3e8d64e762ef?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fHNtaWxpbmclMjBmYWNlfGVufDB8fDB8fA%3D%3D&w=1000&q=80"
                class="p-image"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="exchange-section">
        <div className="container">
          <div className="row">
            <div className="col d-none d-lg-block">
              <div>
                <img
                  src={Bag}
                  data-aos="fade-up"
                  data-aos-anchor-placement="top-center"
                />
              </div>
            </div>
            <div className="col text-center">
              <img src={Hold} data-aos="fade-in" />
              <h2 className="exchange-text" data-aos="fade-down">
                With our exchange system, you are sure of 100% good rate
              </h2>

              <p className="hero-subtext" data-aos="fade-down">
                Create an account with us and start exchanging your crypto
                assets with naira at best rates, easy and seamless.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="card-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <p className="card-title" data-aos="fade-right">
                Free Virtual Cards
              </p>
              <p className="card-subtext" data-aos="fade-right">
                (USD & NGN)
              </p>
              <p className="card-text" data-aos="fade-right">
                Create, manage, and shop with our virtual cards for advanced
                spending controls and real-time authorizations, putting you in
                charge every bit of the way.
              </p>
            </div>
            <div className="col-lg-6 col-md-12">
              <img
                src={Card}
                className="people-card-img"
                data-aos="fade-up"
                data-aos-duration="3000"
                data-aos-anchor-placement="top-center"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="start-section">
        <div className="container">
          <p className="card-title text-center mb-4" data-aos="fade-down">
            Get started in 3 steps
          </p>
          <div className="row top-margin">
            <div className="col">
              <div className="row">
                <div className="col-1" data-aos="zoom-in">
                  <div className="start-bullet">
                    <p className="bullet-text">1</p>
                  </div>
                </div>
                <div className="col-11" data-aos="fade-up"
                >
                  <p className="bullet-main-subtext" >Register</p>
                  <p className="bullet-main-text">
                    Create your account and start exchanging
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-1" data-aos="zoom-in">
                  <div className="start-bullet">
                    <p className="bullet-text">2</p>
                  </div>
                </div>
                <div className="col-11" data-aos="fade-up"
                >
                  <p className="bullet-main-subtext">Exchange</p>
                  <p className="bullet-main-text">
                    Create your account and start exchanging
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-1" data-aos="zoom-in">
                  <div className="start-bullet">
                    <p className="bullet-text">3</p>
                  </div>
                </div>
                <div className="col-11" data-aos="fade-up"
                >
                  <p className="bullet-main-subtext" >Withdraw</p>
                  <p className="bullet-main-text">
                    Create your account and start exchanging
                  </p>
                </div>
              </div>
            </div>
            <div className="col d-none d-lg-block">
              <img
                src={Step}
                className="step-img"
                data-aos="fade-in"
                data-aos-duration="3000"
              /></div>
          </div>
        </div>
      </section>
      <section className="app-section">
        <div className="row">

          <div className="col d-none d-lg-block">
            <img
              src={Phone}
              className="app-img"
              data-aos="fade-in"
            /></div>
          <div className="col text-center download-text">
            <p className="card-title" data-aos="fade-down">Download our mobile app to get started now</p>
            <div className="row" data-aos="flip-left">
              <div className="col-lg-6 col-md-12">
                <a className="btn btn-secondary app-btn" href="/">
                  <img
                    src={Playstore}
                  />
                </a>
              </div>
              <div className="col-lg-6 col-md-12">
                <a className="btn btn-primary app-btn" href="/">
                  <img
                    src={Apple}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="wallet-section">
        <div className="container">
          <div className="row">
            <div className="col"
              data-aos="fade-in">
              <img
                className="wallet-img"
                src={Wallet}
              />
            </div>
            <div className="col">
              <p className="card-title" style={{ color: '#ffffff' }} data-aos="fade-down">Maximum Wallet Security</p>
              <p className="card-text" style={{ color: '#ffffff' }} data-aos="fade-down">
                We guarantee absolute secured and protected exchange enviroment with
                top level data and asset exchange encryption models.
                <br /><br />
                All transactions require multi factor authentication and autorizations
                to allow for transaction credibility.
                <br /><br />
                We guarantee absolute secured and protected exchange enviroment with
                top level data and asset exchange encryption models.
                <br /><br />
                All transactions require multi factor authentication and autorizations
                to allow for transaction credibility.
                We guarantee absolute secured and protected exchange enviroment with
                top level data and asset exchange encryption models.
                <br /><br />
                All transactions require multi factor authentication and autorizations
                to allow for transaction credibility.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="footer-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-12">
              <p className="footer-header">Xtrava Africa</p>
              <p className="footer-link"><a href="">Home</a></p>
              <p className="footer-link"><a href="">About Us</a></p>
              <p className="footer-link"><a href="">Contact Us</a></p>
            </div>
            <div className="col-lg-3 col-md-12">
              <p className="footer-header">Services</p>
              <p className="footer-link"><a href="">Crypto Exchange</a></p>
              <p className="footer-link"><a href="">Virtal Cards</a></p>
              <p className="footer-link"><a href="">Bureau de Change</a></p>
            </div>
            <div className="col-lg-3 col-md-12">
              <p className="footer-header">Support</p>
              <p className="footer-link"><a href="">Chat with us</a></p>
              <p className="footer-link"><a href="">Email us</a></p>
            </div>
            <div className="col-lg-3 col-md-12">
              <p className="footer-header">Location</p>
              <p className="footer-link">Lagos, Nigeria</p>
              <br />
              <p className="footer-header">Telephone</p>
              <p className="footer-link">+2347041010050</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default LandingPage;
